import './checkout/cart'
import { enhanceCheckoutStepLabel, initCartStepLabel } from './checkout/add-checkout-steps'
import { enhanceAddCheckoutText } from './checkout/add-checkout-text'
import { enhanceHideAddressField } from './checkout/hide-address-field'
import { enhanceMovePhoneField } from './checkout/move-phone-field'
import { initLabelReplacements } from './checkout/replace-labels'
import { getCheckoutRoot, observeCheckoutEnhancements } from './checkout/utils'

document.addEventListener('DOMContentLoaded', () => {
	initLabelReplacements()
	initCartStepLabel()

	const root = getCheckoutRoot()

	observeCheckoutEnhancements(root, () => {
		enhanceCheckoutStepLabel(root)
		enhanceHideAddressField(root)
		enhanceMovePhoneField(root)
		enhanceAddCheckoutText(root)
	})
})
